// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mt-20 {
    margin-top: 20px
}

.mt-10 {
    margin-top: 10px;
}

.d-flex {
    display: flex;
}

.d-block {
    display: block;
}

.justify-content-space-between {
    justify-content: space-between;
}

.align-items-center {
    align-items: center;
}

.currency-settings-dropdown {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.Polaris-TextContainer .Polaris-LegacyStack .Polaris-LegacyStack__Item {
    margin-top: 10px;
}

.Polaris-TextContainer .Polaris-LegacyStack {
    padding-top: 5px;
}


/* .hw-currencyLocation--main-div .hw-currency-show {
    position: absolute;
    left: 0;
    right: 0;
    width: 50%;
    margin: 0 auto;
    top: 0;
    height: 100%;
} */

.hw-currencyLocation--main-div input[type="checkbox"] {
    width: 18px;
    height: 18px;
}

.hw-currencyLocation--main-div img {
    width: 100%;
    height: auto;
    max-width: 350px;
    /* margin-left: -40px; */
}

.hw-currencyLocation--main-div {
    position: relative;
}

/* .hw-currencyLocation--main-div .hw-currency-show div:first-child {
    position: absolute;
    left: 0;
    top: 30px;
} */

/* .hw-currencyLocation--main-div .hw-currency-show div:nth-child(2) {
    position: absolute;
    right: 0;
    top: 30px;
} */

/* .hw-currencyLocation--main-div .hw-currency-show div:nth-child(3) {
    position: absolute;
    left: 0;
    bottom: 62px;
} */

/* .hw-currencyLocation--main-div .hw-currency-show div:nth-child(4) {
    position: absolute;
    right: 0;
    bottom: 62px;
} */

.preview-container {
    margin-top: 2vh;
    padding: 1em;
    background-color: #f9fafb;
    border-radius: 0.5em;
}

.header-preview {
    border: 0.0625em solid #e1e3e5;
    border-radius: 0.5em;
    padding: 1em;
}

.header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header-content-logo {
    font-weight: bold;
    font-size: 0.875em;
    color: #6d7175;
}

.inline-header-nav-items {
    display: flex;
    gap: 2em;
    align-items: center;
}

.inline-header-nav-items span {
    color: #6d7175;
}

.inline-header-currency-switcher {
    display: flex;
    align-items: center;
    gap: 0.5em;
    padding: 0.5em 1em;
    background-color: #ededed;
    border-radius: 0.25em;
    cursor: pointer;
}

.inline-header-currency-switcher:hover {
    background-color: #e1e3e5;
}

.disabled-preview {
    margin-top: 2vh;
    padding: 2em;
    background-color: #f9fafb;
    border-radius: 0.5em;
    text-align: center;
}

.disabled-icon {
    font-size: 2em;
    margin-bottom: 1em;
}

.color-input-textfield {
    appearance: none;
    inline-size: 2.2em;
    block-size: 2.2em;
    border-width: 0;
    padding: 0;
    margin-left: 0.5em;
    margin-top: 0.5em;
    background: none;
    cursor: pointer;
}

.color-input-textfield::-webkit-color-swatch-wrapper {
    padding: 0;
}

.color-input-textfield::-webkit-color-swatch {
    border: none;
    border-radius: 0.25em;
}

.advance-custimization-main-div .Polaris-BlockStack {
    margin-top: 10px;
}


.custom-css-container {
    margin-top: 1em;
    padding: 1.5em;
    background-color: #f9fafb;
    border-radius: 8px;
    border: 1px solid #e1e3e5;
}

.custom-css-container .Polaris-TextField {
    margin-bottom: 0;
}

.extra-config-badge-div .Polaris-Badge {
    margin-left: 10px;
}

.pricing-rules-extra-config {
    display: flex;
    flex-direction: column;
    gap: 10px;
}


.store-integration-step {
    display: flex;
    flex-direction: column;
    gap: 0.5em;
}

.store-integration-html-with-currency-div {
    margin-top: 3px;
    width: 75%;
    margin-left: 2rem;
}

.hw-currencyLocation--main-div {

    max-width: 350px;
    margin: 0 auto;
    margin-top: 15px;
}

.hw-currencyLocation--main-div .top-left {
    position: absolute;
    top: 25px;
    left: 50px;
}

.hw-currencyLocation--main-div .top-right {
    position: absolute;
    top: 25px;
    right: 50px;
}

.hw-currencyLocation--main-div .bottom-right {
    position: absolute;
    bottom: 40px;
    right: 50px;
}

.hw-currencyLocation--main-div .bottom-left {
    position: absolute;
    bottom: 40px;
    left: 50px;
}

.previewContainer {
    margin-top: 2em;
    padding: 1.5em;
    background-color: #f9fafb;
    border-radius: 8px;
    border: 1px solid #e1e3e5;
}

.previewBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    margin-top: 1em;
    min-height: 60px;
}

.previewSelect {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 18vw;
    max-width: 300px;
    height: 40px;
    padding: 0 4px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
    background-color: var(--background-color);
    color: var(--text-color);
    z-index: 2;

}

.previewSelect:hover {
    background-color: var(--background-hover-color);
    color: var(--text-hover-color);
}

.previewSelect:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 128, 96, 0.2);
}

.previewSelect.open {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}

.previewContent {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
    flex: 1;
}

.flagPreview {
    width: 24px;
    height: 18px;
    overflow: hidden;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    margin-right: 0.5em;
    flex-shrink: 0;
}

.flagPreview.circleFlag {
    border-radius: 50%;
    height: 24px;
    aspect-ratio: 1 / 1;
}

.flagImage {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.currencyInfo {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-left: -0.5em;
    min-width: 0;
    flex: 1;
}

.currencyName {
    font-weight: 500;
    font-size: 14px;
    margin-left: 0.5vw;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.currencySymbol {
    font-size: 12px;
    opacity: 0.8;
    margin-left: 4px;
    white-space: nowrap;
}

.selectArrow {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    color: currentColor;
    opacity: 0.6;
    transition: transform 0.2s ease;
    flex-shrink: 0;
}

.previewSelect:hover .selectArrow {
    opacity: 1;
}

.pricePreview {
    font-weight: 600;
    font-size: 14px;
    color: #202223;
    background-color: #f0f0f0;
    padding: 0.6em;
    border-radius: 0.25em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.pricePreview .currencyCode {
    font-size: 12px;
    opacity: 0.8;
    margin-left: 4px;
}

.previewDropdown {
    position: absolute;
    top: 100%;
    left: 0;
    width: 22vw;
    max-width: 300px;
    margin-top: -1px;
    border: 1px solid #e1e3e5;
    border-top: none;
    border-radius: 0 0 4px 4px;
    background-color: #fff;
    max-height: 41vh;
    overflow-y: auto;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    animation: dropdownFadeIn 0.2s ease-in-out;
    z-index: 1;
}

@keyframes dropdownFadeIn {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.previewDropdownItem {
    display: flex;
    align-items: center;
    padding: 8px 1em;
    cursor: pointer;
    transition: all 0.2s ease;
    background-color: var(--background-color);
    border-bottom: 1px solid #f1f1f1;
    color: var(--text-color);
    border: none !important;
}

.previewDropdownItem:hover {
    background-color: var(--background-hover-color);
    color: var(--text-hover-color);
}

.previewDropdownItem:last-child {
    border-bottom: none;
}



.space {
    padding: 5px 0;
}

/* ---- Huptech app suite / recommended apps cards ---- */
.hw-app-card {
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: 100%;
    box-sizing: border-box;
    padding: 20px;
    background: var(--p-color-bg-surface, #ffffff);
    border: 1px solid var(--p-color-border-secondary, #e1e3e5);
    border-radius: 12px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
.hw-app-top {
    display: flex;
    align-items: center;
    gap: 16px;
}
.hw-app-logo {
    width: 60px;
    height: 60px;
    border-radius: 14px;
    object-fit: cover;
    flex: 0 0 auto;
    display: block;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.10);
}
.hw-app-logo-fallback {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-weight: 700;
    font-size: 22px;
    letter-spacing: -0.02em;
}
.hw-app-head {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
}
.hw-app-name {
    font-size: 18px;
    font-weight: 650;
    line-height: 1.25;
    margin: 0;
    color: var(--p-color-text, #1a1a1a);
}
.hw-app-badge {
    align-self: flex-start;
    font-size: 11px;
    font-weight: 600;
    color: #0c447c;
    background: #e6f1fb;
    padding: 2px 9px;
    border-radius: 999px;
}
.hw-app-badge-installed {
    align-self: flex-start;
    font-size: 11px;
    font-weight: 600;
    color: #0c5132;
    background: #cdfee1;
    padding: 2px 9px;
    border-radius: 999px;
}
.hw-app-desc {
    font-size: 14.5px;
    line-height: 1.55;
    color: var(--p-color-text-secondary, #616161);
    margin: 0;
}
.hw-app-btn {
    margin-top: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    height: 48px;
    border-radius: 12px;
    background: #000000;
    color: #ffffff;
    font-size: 15px;
    font-weight: 600;
    text-decoration: none;
    cursor: pointer;
    border: 1.5px solid #000000;
    transition: background 0.15s ease, color 0.15s ease, transform 0.08s ease;
}
.hw-app-btn:hover {
    background: #ffffff;
    color: #000000;
}
.hw-app-btn:active {
    background: #ffffff;
    color: #000000;
    transform: scale(0.985);
}
.hw-app-btn svg {
    width: 16px;
    height: 16px;
    fill: currentColor;
}
.hw-app-btn-off {
    margin-top: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 48px;
    border-radius: 12px;
    background: var(--p-color-bg-surface-secondary, #f1f1f1);
    color: var(--p-color-text-disabled, #8a8a8a);
    font-size: 15px;
    font-weight: 600;
    border: 1.5px solid transparent;
    cursor: default;
}
.hw-app-section-title {
    font-size: 20px;
    font-weight: 650;
    line-height: 1.2;
    margin: 0;
    color: var(--p-color-text, #1a1a1a);
}
.hw-app-section-sub {
    font-size: 14px;
    margin: 4px 0 0;
    color: var(--p-color-text-secondary, #616161);
}
/* Button pinned to the bottom so cards line up regardless of description length. */
.hw-app-action {
    margin-top: auto;
    width: 100%;
}
.hw-app-pbtn {
    display: inline-block;
}
/* Black "Install now" - a Polaris primary button styled black, swapping to white on hover/click. */
.hw-app-pbtn .Polaris-Button,
.hw-app-pbtn .Polaris-Button * {
    color: #ffffff !important;
}
.hw-app-pbtn .Polaris-Button {
    background: #000000 !important;
    background-color: #000000 !important;
    border-color: #000000 !important;
    box-shadow: none !important;
    transition: background-color 0.15s ease, color 0.15s ease;
}
.hw-app-pbtn .Polaris-Button:hover,
.hw-app-pbtn .Polaris-Button:focus-visible,
.hw-app-pbtn .Polaris-Button:active {
    background: #ffffff !important;
    background-color: #ffffff !important;
    border-color: #000000 !important;
}
.hw-app-pbtn .Polaris-Button:hover,
.hw-app-pbtn .Polaris-Button:hover *,
.hw-app-pbtn .Polaris-Button:focus-visible,
.hw-app-pbtn .Polaris-Button:focus-visible *,
.hw-app-pbtn .Polaris-Button:active,
.hw-app-pbtn .Polaris-Button:active * {
    color: #000000 !important;
    border-color: #000000 !important;
}
/* Recommended apps - dismissible boxed table */
.hw-rec-close {
    border: 0;
    background: transparent;
    cursor: pointer;
    font-size: 16px;
    line-height: 1;
    color: var(--p-color-icon-subdued, #8a8a8a);
    padding: 4px 6px;
    border-radius: 6px;
    flex: 0 0 auto;
}
.hw-rec-close:hover {
    color: var(--p-color-icon, #4a4a4a);
    background: var(--p-color-bg-surface-secondary, #f1f1f1);
}
.hw-rec-logo {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    object-fit: cover;
    display: block;
    flex: 0 0 auto;
}
.hw-rec-logo-fallback {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-weight: 700;
    font-size: 15px;
    letter-spacing: -0.02em;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAAA;IACI;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;;;;;;;;GAQG;;AAEH;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;;GAIG;;AAEH;;;;GAIG;;AAEH;;;;GAIG;;AAEH;;;;GAIG;;AAEH;IACI,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;IAC9B,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,UAAU;IACV,iBAAiB;AACrB;;AAEA;;IAEI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,yCAAyC;IACzC,wBAAwB;IACxB,UAAU;;AAEd;;AAEA;IACI,+CAA+C;IAC/C,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,2CAA2C;AAC/C;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,OAAO;AACX;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,wCAAwC;IACxC,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,YAAY;IACZ,OAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;IAC1B,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,wCAAwC;IACxC,0CAA0C;IAC1C,UAAU;AACd;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,yCAAyC;IACzC,gCAAgC;IAChC,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;IACI,+CAA+C;IAC/C,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;;;AAIA;IACI,cAAc;AAClB;;AAEA,yDAAyD;AACzD;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,8CAA8C;IAC9C,0DAA0D;IAC1D,mBAAmB;IACnB,yCAAyC;AAC7C;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,cAAc;IACd,yCAAyC;AAC7C;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,mCAAmC;AACvC;AACA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,6CAA6C;IAC7C,SAAS;AACb;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,2BAA2B;IAC3B,yEAAyE;AAC7E;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,wDAAwD;IACxD,4CAA4C;IAC5C,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,mCAAmC;AACvC;AACA;IACI,eAAe;IACf,eAAe;IACf,6CAA6C;AACjD;AACA,mFAAmF;AACnF;IACI,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,qBAAqB;AACzB;AACA,mGAAmG;AACnG;;IAEI,yBAAyB;AAC7B;AACA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,gCAAgC;IAChC,2BAA2B;IAC3B,yDAAyD;AAC7D;AACA;;;IAGI,8BAA8B;IAC9B,oCAAoC;IACpC,gCAAgC;AACpC;AACA;;;;;;IAMI,yBAAyB;IACzB,gCAAgC;AACpC;AACA,+CAA+C;AAC/C;IACI,SAAS;IACT,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,cAAc;IACd,2CAA2C;IAC3C,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,mCAAmC;IACnC,wDAAwD;AAC5D;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,cAAc;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,uBAAuB;AAC3B","sourcesContent":[".mt-20 {\r\n    margin-top: 20px\r\n}\r\n\r\n.mt-10 {\r\n    margin-top: 10px;\r\n}\r\n\r\n.d-flex {\r\n    display: flex;\r\n}\r\n\r\n.d-block {\r\n    display: block;\r\n}\r\n\r\n.justify-content-space-between {\r\n    justify-content: space-between;\r\n}\r\n\r\n.align-items-center {\r\n    align-items: center;\r\n}\r\n\r\n.currency-settings-dropdown {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n}\r\n\r\n.Polaris-TextContainer .Polaris-LegacyStack .Polaris-LegacyStack__Item {\r\n    margin-top: 10px;\r\n}\r\n\r\n.Polaris-TextContainer .Polaris-LegacyStack {\r\n    padding-top: 5px;\r\n}\r\n\r\n\r\n/* .hw-currencyLocation--main-div .hw-currency-show {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    width: 50%;\r\n    margin: 0 auto;\r\n    top: 0;\r\n    height: 100%;\r\n} */\r\n\r\n.hw-currencyLocation--main-div input[type=\"checkbox\"] {\r\n    width: 18px;\r\n    height: 18px;\r\n}\r\n\r\n.hw-currencyLocation--main-div img {\r\n    width: 100%;\r\n    height: auto;\r\n    max-width: 350px;\r\n    /* margin-left: -40px; */\r\n}\r\n\r\n.hw-currencyLocation--main-div {\r\n    position: relative;\r\n}\r\n\r\n/* .hw-currencyLocation--main-div .hw-currency-show div:first-child {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 30px;\r\n} */\r\n\r\n/* .hw-currencyLocation--main-div .hw-currency-show div:nth-child(2) {\r\n    position: absolute;\r\n    right: 0;\r\n    top: 30px;\r\n} */\r\n\r\n/* .hw-currencyLocation--main-div .hw-currency-show div:nth-child(3) {\r\n    position: absolute;\r\n    left: 0;\r\n    bottom: 62px;\r\n} */\r\n\r\n/* .hw-currencyLocation--main-div .hw-currency-show div:nth-child(4) {\r\n    position: absolute;\r\n    right: 0;\r\n    bottom: 62px;\r\n} */\r\n\r\n.preview-container {\r\n    margin-top: 2vh;\r\n    padding: 1em;\r\n    background-color: #f9fafb;\r\n    border-radius: 0.5em;\r\n}\r\n\r\n.header-preview {\r\n    border: 0.0625em solid #e1e3e5;\r\n    border-radius: 0.5em;\r\n    padding: 1em;\r\n}\r\n\r\n.header-content {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.header-content-logo {\r\n    font-weight: bold;\r\n    font-size: 0.875em;\r\n    color: #6d7175;\r\n}\r\n\r\n.inline-header-nav-items {\r\n    display: flex;\r\n    gap: 2em;\r\n    align-items: center;\r\n}\r\n\r\n.inline-header-nav-items span {\r\n    color: #6d7175;\r\n}\r\n\r\n.inline-header-currency-switcher {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.5em;\r\n    padding: 0.5em 1em;\r\n    background-color: #ededed;\r\n    border-radius: 0.25em;\r\n    cursor: pointer;\r\n}\r\n\r\n.inline-header-currency-switcher:hover {\r\n    background-color: #e1e3e5;\r\n}\r\n\r\n.disabled-preview {\r\n    margin-top: 2vh;\r\n    padding: 2em;\r\n    background-color: #f9fafb;\r\n    border-radius: 0.5em;\r\n    text-align: center;\r\n}\r\n\r\n.disabled-icon {\r\n    font-size: 2em;\r\n    margin-bottom: 1em;\r\n}\r\n\r\n.color-input-textfield {\r\n    appearance: none;\r\n    inline-size: 2.2em;\r\n    block-size: 2.2em;\r\n    border-width: 0;\r\n    padding: 0;\r\n    margin-left: 0.5em;\r\n    margin-top: 0.5em;\r\n    background: none;\r\n    cursor: pointer;\r\n}\r\n\r\n.color-input-textfield::-webkit-color-swatch-wrapper {\r\n    padding: 0;\r\n}\r\n\r\n.color-input-textfield::-webkit-color-swatch {\r\n    border: none;\r\n    border-radius: 0.25em;\r\n}\r\n\r\n.advance-custimization-main-div .Polaris-BlockStack {\r\n    margin-top: 10px;\r\n}\r\n\r\n\r\n.custom-css-container {\r\n    margin-top: 1em;\r\n    padding: 1.5em;\r\n    background-color: #f9fafb;\r\n    border-radius: 8px;\r\n    border: 1px solid #e1e3e5;\r\n}\r\n\r\n.custom-css-container .Polaris-TextField {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.extra-config-badge-div .Polaris-Badge {\r\n    margin-left: 10px;\r\n}\r\n\r\n.pricing-rules-extra-config {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n}\r\n\r\n\r\n.store-integration-step {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 0.5em;\r\n}\r\n\r\n.store-integration-html-with-currency-div {\r\n    margin-top: 3px;\r\n    width: 75%;\r\n    margin-left: 2rem;\r\n}\r\n\r\n.hw-currencyLocation--main-div {\r\n\r\n    max-width: 350px;\r\n    margin: 0 auto;\r\n    margin-top: 15px;\r\n}\r\n\r\n.hw-currencyLocation--main-div .top-left {\r\n    position: absolute;\r\n    top: 25px;\r\n    left: 50px;\r\n}\r\n\r\n.hw-currencyLocation--main-div .top-right {\r\n    position: absolute;\r\n    top: 25px;\r\n    right: 50px;\r\n}\r\n\r\n.hw-currencyLocation--main-div .bottom-right {\r\n    position: absolute;\r\n    bottom: 40px;\r\n    right: 50px;\r\n}\r\n\r\n.hw-currencyLocation--main-div .bottom-left {\r\n    position: absolute;\r\n    bottom: 40px;\r\n    left: 50px;\r\n}\r\n\r\n.previewContainer {\r\n    margin-top: 2em;\r\n    padding: 1.5em;\r\n    background-color: #f9fafb;\r\n    border-radius: 8px;\r\n    border: 1px solid #e1e3e5;\r\n}\r\n\r\n.previewBox {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    position: relative;\r\n    margin-top: 1em;\r\n    min-height: 60px;\r\n}\r\n\r\n.previewSelect {\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    width: 18vw;\r\n    max-width: 300px;\r\n    height: 40px;\r\n    padding: 0 4px;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    transition: all 0.2s ease;\r\n    background-color: var(--background-color);\r\n    color: var(--text-color);\r\n    z-index: 2;\r\n\r\n}\r\n\r\n.previewSelect:hover {\r\n    background-color: var(--background-hover-color);\r\n    color: var(--text-hover-color);\r\n}\r\n\r\n.previewSelect:focus {\r\n    outline: none;\r\n    box-shadow: 0 0 0 2px rgba(0, 128, 96, 0.2);\r\n}\r\n\r\n.previewSelect.open {\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n}\r\n\r\n.previewContent {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n    min-width: 0;\r\n    flex: 1;\r\n}\r\n\r\n.flagPreview {\r\n    width: 24px;\r\n    height: 18px;\r\n    overflow: hidden;\r\n    border-radius: 2px;\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n    margin-right: 0.5em;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.flagPreview.circleFlag {\r\n    border-radius: 50%;\r\n    height: 24px;\r\n    aspect-ratio: 1 / 1;\r\n}\r\n\r\n.flagImage {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n}\r\n\r\n.currencyInfo {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n    margin-left: -0.5em;\r\n    min-width: 0;\r\n    flex: 1;\r\n}\r\n\r\n.currencyName {\r\n    font-weight: 500;\r\n    font-size: 14px;\r\n    margin-left: 0.5vw;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.currencySymbol {\r\n    font-size: 12px;\r\n    opacity: 0.8;\r\n    margin-left: 4px;\r\n    white-space: nowrap;\r\n}\r\n\r\n.selectArrow {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 20px;\r\n    height: 20px;\r\n    color: currentColor;\r\n    opacity: 0.6;\r\n    transition: transform 0.2s ease;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.previewSelect:hover .selectArrow {\r\n    opacity: 1;\r\n}\r\n\r\n.pricePreview {\r\n    font-weight: 600;\r\n    font-size: 14px;\r\n    color: #202223;\r\n    background-color: #f0f0f0;\r\n    padding: 0.6em;\r\n    border-radius: 0.25em;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.pricePreview .currencyCode {\r\n    font-size: 12px;\r\n    opacity: 0.8;\r\n    margin-left: 4px;\r\n}\r\n\r\n.previewDropdown {\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 0;\r\n    width: 22vw;\r\n    max-width: 300px;\r\n    margin-top: -1px;\r\n    border: 1px solid #e1e3e5;\r\n    border-top: none;\r\n    border-radius: 0 0 4px 4px;\r\n    background-color: #fff;\r\n    max-height: 41vh;\r\n    overflow-y: auto;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n    animation: dropdownFadeIn 0.2s ease-in-out;\r\n    z-index: 1;\r\n}\r\n\r\n@keyframes dropdownFadeIn {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(-10px);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n.previewDropdownItem {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 8px 1em;\r\n    cursor: pointer;\r\n    transition: all 0.2s ease;\r\n    background-color: var(--background-color);\r\n    border-bottom: 1px solid #f1f1f1;\r\n    color: var(--text-color);\r\n    border: none !important;\r\n}\r\n\r\n.previewDropdownItem:hover {\r\n    background-color: var(--background-hover-color);\r\n    color: var(--text-hover-color);\r\n}\r\n\r\n.previewDropdownItem:last-child {\r\n    border-bottom: none;\r\n}\r\n\r\n\r\n\r\n.space {\r\n    padding: 5px 0;\r\n}\r\n\r\n/* ---- Huptech app suite / recommended apps cards ---- */\r\n.hw-app-card {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 16px;\r\n    height: 100%;\r\n    box-sizing: border-box;\r\n    padding: 20px;\r\n    background: var(--p-color-bg-surface, #ffffff);\r\n    border: 1px solid var(--p-color-border-secondary, #e1e3e5);\r\n    border-radius: 12px;\r\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\r\n}\r\n.hw-app-top {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 16px;\r\n}\r\n.hw-app-logo {\r\n    width: 60px;\r\n    height: 60px;\r\n    border-radius: 14px;\r\n    object-fit: cover;\r\n    flex: 0 0 auto;\r\n    display: block;\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.10);\r\n}\r\n.hw-app-logo-fallback {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    color: #ffffff;\r\n    font-weight: 700;\r\n    font-size: 22px;\r\n    letter-spacing: -0.02em;\r\n}\r\n.hw-app-head {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 6px;\r\n    min-width: 0;\r\n}\r\n.hw-app-name {\r\n    font-size: 18px;\r\n    font-weight: 650;\r\n    line-height: 1.25;\r\n    margin: 0;\r\n    color: var(--p-color-text, #1a1a1a);\r\n}\r\n.hw-app-badge {\r\n    align-self: flex-start;\r\n    font-size: 11px;\r\n    font-weight: 600;\r\n    color: #0c447c;\r\n    background: #e6f1fb;\r\n    padding: 2px 9px;\r\n    border-radius: 999px;\r\n}\r\n.hw-app-badge-installed {\r\n    align-self: flex-start;\r\n    font-size: 11px;\r\n    font-weight: 600;\r\n    color: #0c5132;\r\n    background: #cdfee1;\r\n    padding: 2px 9px;\r\n    border-radius: 999px;\r\n}\r\n.hw-app-desc {\r\n    font-size: 14.5px;\r\n    line-height: 1.55;\r\n    color: var(--p-color-text-secondary, #616161);\r\n    margin: 0;\r\n}\r\n.hw-app-btn {\r\n    margin-top: auto;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 8px;\r\n    width: 100%;\r\n    height: 48px;\r\n    border-radius: 12px;\r\n    background: #000000;\r\n    color: #ffffff;\r\n    font-size: 15px;\r\n    font-weight: 600;\r\n    text-decoration: none;\r\n    cursor: pointer;\r\n    border: 1.5px solid #000000;\r\n    transition: background 0.15s ease, color 0.15s ease, transform 0.08s ease;\r\n}\r\n.hw-app-btn:hover {\r\n    background: #ffffff;\r\n    color: #000000;\r\n}\r\n.hw-app-btn:active {\r\n    background: #ffffff;\r\n    color: #000000;\r\n    transform: scale(0.985);\r\n}\r\n.hw-app-btn svg {\r\n    width: 16px;\r\n    height: 16px;\r\n    fill: currentColor;\r\n}\r\n.hw-app-btn-off {\r\n    margin-top: auto;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 100%;\r\n    height: 48px;\r\n    border-radius: 12px;\r\n    background: var(--p-color-bg-surface-secondary, #f1f1f1);\r\n    color: var(--p-color-text-disabled, #8a8a8a);\r\n    font-size: 15px;\r\n    font-weight: 600;\r\n    border: 1.5px solid transparent;\r\n    cursor: default;\r\n}\r\n.hw-app-section-title {\r\n    font-size: 20px;\r\n    font-weight: 650;\r\n    line-height: 1.2;\r\n    margin: 0;\r\n    color: var(--p-color-text, #1a1a1a);\r\n}\r\n.hw-app-section-sub {\r\n    font-size: 14px;\r\n    margin: 4px 0 0;\r\n    color: var(--p-color-text-secondary, #616161);\r\n}\r\n/* Button pinned to the bottom so cards line up regardless of description length. */\r\n.hw-app-action {\r\n    margin-top: auto;\r\n    width: 100%;\r\n}\r\n.hw-app-pbtn {\r\n    display: inline-block;\r\n}\r\n/* Black \"Install now\" - a Polaris primary button styled black, swapping to white on hover/click. */\r\n.hw-app-pbtn .Polaris-Button,\r\n.hw-app-pbtn .Polaris-Button * {\r\n    color: #ffffff !important;\r\n}\r\n.hw-app-pbtn .Polaris-Button {\r\n    background: #000000 !important;\r\n    background-color: #000000 !important;\r\n    border-color: #000000 !important;\r\n    box-shadow: none !important;\r\n    transition: background-color 0.15s ease, color 0.15s ease;\r\n}\r\n.hw-app-pbtn .Polaris-Button:hover,\r\n.hw-app-pbtn .Polaris-Button:focus-visible,\r\n.hw-app-pbtn .Polaris-Button:active {\r\n    background: #ffffff !important;\r\n    background-color: #ffffff !important;\r\n    border-color: #000000 !important;\r\n}\r\n.hw-app-pbtn .Polaris-Button:hover,\r\n.hw-app-pbtn .Polaris-Button:hover *,\r\n.hw-app-pbtn .Polaris-Button:focus-visible,\r\n.hw-app-pbtn .Polaris-Button:focus-visible *,\r\n.hw-app-pbtn .Polaris-Button:active,\r\n.hw-app-pbtn .Polaris-Button:active * {\r\n    color: #000000 !important;\r\n    border-color: #000000 !important;\r\n}\r\n/* Recommended apps - dismissible boxed table */\r\n.hw-rec-close {\r\n    border: 0;\r\n    background: transparent;\r\n    cursor: pointer;\r\n    font-size: 16px;\r\n    line-height: 1;\r\n    color: var(--p-color-icon-subdued, #8a8a8a);\r\n    padding: 4px 6px;\r\n    border-radius: 6px;\r\n    flex: 0 0 auto;\r\n}\r\n.hw-rec-close:hover {\r\n    color: var(--p-color-icon, #4a4a4a);\r\n    background: var(--p-color-bg-surface-secondary, #f1f1f1);\r\n}\r\n.hw-rec-logo {\r\n    width: 40px;\r\n    height: 40px;\r\n    border-radius: 10px;\r\n    object-fit: cover;\r\n    display: block;\r\n    flex: 0 0 auto;\r\n}\r\n.hw-rec-logo-fallback {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    color: #ffffff;\r\n    font-weight: 700;\r\n    font-size: 15px;\r\n    letter-spacing: -0.02em;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
